import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import { SET_YANDEX_DATA_FAILED, SET_YANDEX_DATA_SUCCESS, GET_YANDEX_DATA_FAILED, GET_YANDEX_DATA_SUCCESS, ADD_NEW_YANDEX_SUCCESS, ADD_NEW_YANDEX_FAILED, ADD_NEW_YANDEX_CSV_FAILED, ADD_NEW_YANDEX_CSV_SUCCESS } from "../Actions/YandexActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* GetYandexDataSaga():unknown{
  try {
    const response = yield call(axios.get, "getYandexData");
      const { data, status } = response;
      //console.log(data)
      if (status === 200) {
        yield put({ type: GET_YANDEX_DATA_SUCCESS, payload: data });
      }
  } catch (error:any) {
      
      if (error.response.status === 500) {
          if (error.response.data.message) {
            yield put({
              type: TOAST_SHOW,
              payload: { message: error.response.data.message, severity: 'Danger', show: true },
            });
          }
        } else {
          yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
          });
        }

      yield put({type:GET_YANDEX_DATA_FAILED})
      
  }
}

export function* SetYandexDataSaga(action:any):unknown{
    try {
        const response = yield call(axios.post,'setYandexData',action.payload)
        const {data,status} = response
        if (status===200||status===204) {
            yield put({type:SET_YANDEX_DATA_SUCCESS,payload:data})
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'New Yandex added successfully', severity: 'Success', show: true },
            });

            let {handleSuccess} = action.payload;
            if(handleSuccess){  
                handleSuccess(data) 
            }
        }
    } catch (error:any) {
        
        if (error.response.status === 500) {
            if (error.response.data.message) {
              yield put({
                type: TOAST_SHOW,
                payload: { message: error.response.data.message, severity: 'Danger', show: true },
              });
            }
          } else {
            yield put({
              type: TOAST_SHOW,
              payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
            });
          }

        yield put({type:SET_YANDEX_DATA_FAILED})
        
    }
}

export function* AddNewYandexSaga(action:any):unknown{
  try {
      const response = yield call(axios.post,'newYandex',action.payload)
      const {data,status} = response
      if (status===200||status===204) {
          yield put({type:ADD_NEW_YANDEX_SUCCESS,payload:data})
          yield put({
              type: TOAST_SHOW,
              payload: { message: 'New Yandex added successfully', severity: 'Success', show: true },
          });

          let {handleSuccess} = action.payload;
          if(handleSuccess){  
              handleSuccess(data) 
          }
      }
  } catch (error:any) {
      
      if (error.response.status === 500) {
          if (error.response.data.message) {
            yield put({
              type: TOAST_SHOW,
              payload: { message: error.response.data.message, severity: 'Danger', show: true },
            });
          }
        } else {
          yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
          });
        }

      yield put({type:ADD_NEW_YANDEX_FAILED})
      
  }
}

export function* AddNewYandexCSVSaga(action:any):unknown{
  try {
    console.log(action.payload);
      const response = yield call(axios.post,'newYandexCSV',action.payload)
      
      const {data,status} = response
      if (status===200||status===204) {
          yield put({type:ADD_NEW_YANDEX_CSV_SUCCESS,payload:data})
          yield put({
              type: TOAST_SHOW,
              payload: { message: 'New Yandex added successfully', severity: 'Success', show: true },
          });

          let {handleSuccess} = action.payload;
          if(handleSuccess){  
              handleSuccess(data) 
          }
      }
  } catch (error:any) {
      
      if (error.response.status === 500) {
          if (error.response.data.message) {
            yield put({
              type: TOAST_SHOW,
              payload: { message: error.response.data.message, severity: 'Danger', show: true },
            });
          }
        } else {
          yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
          });
        }

      yield put({type:ADD_NEW_YANDEX_CSV_FAILED})
      
  }
}
